module.exports = __webpack_public_path__ + "img/img_clients6.9e5b345e.jpg";